import React, { useEffect, useState } from 'react';
import AlphabetFilter from './AlphabetFilter';
import GlossaryList from './GlossaryList';
import SearchGeneric from 'components/Fields/Search/SearchGeneric';
import api from 'api';

const Glossary = ({ term }: any) => {
  const [search, setSearch] = useState(term || '');
  const [selectedLetters, setSelectedLetters] = useState([]);

  const [glossary, setGlossary] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    api.getGlossary().then(response => {
      setIsLoading(false);
      setGlossary(response.data.results);
    });
    // eslint-disable-next-line
  }, []);

  const handleSelectLetter = (letter: any) => {
    setSearch('');
    setSelectedLetters((prev: any) =>
      prev.includes(letter)
        ? prev.filter((l: any) => l !== letter)
        : [...prev, letter]
    );
  };

  const reset = () => {
    setSearch('');
    setSelectedLetters([]);
  };

  return (
    <>
      <SearchGeneric
        label="Search the glossary"
        onSearch={setSearch}
        defaultValue={term || ''}
      />
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          alignItems: 'center'
        }}
      >
        <AlphabetFilter
          selectedLetters={selectedLetters}
          onSelect={handleSelectLetter}
          isLoading={isLoading}
          glossary={glossary}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            marginRight: '0.6rem'
          }}
          className="dashboardLink"
          onClick={() => reset()}
        >
          Reset Filters
        </div>
      </div>
      <GlossaryList
        search={search}
        isLoading={isLoading}
        glossary={glossary}
        selectedLetters={selectedLetters}
      />
    </>
  );
};

export default Glossary;
